<app-vss-organization-menu [id]="currentOrganizationId"></app-vss-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;" #sectionToScroll>
    <h4 class="border-bottom pb-2 color-primary mb-3">{{'VSS.TRAINING.title' | translate}}
        <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
            {{'VSS.TRAINING.titleHelpText' | translate}}
        </small>
    </h4>
    <section *ngIf="scheduleAction">
        <form #scheduleForm='ngForm' (ngSubmit)="onScheduleSubmit()" [formGroup]="scheduleFormGroup">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{'VSS.TRAINING.FORM.description' | translate}} DE</label>
                        <input type="text" class="form-control form-control-sm" id="name_de" name="name_de"
                            formControlName="name_de" placeholder="zB. " />
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'VSS.TRAINING.FORM.description' | translate}} IT</label>
                        <input type="text" class="form-control form-control-sm" id="name_it" name="name_it"
                            formControlName="name_it" placeholder="Esempio: " />
                        <span class="small form-text text-danger"
                            *ngIf="scheduleFormGroup.hasError('emptyScheduleName')">
                            {{'VSS.TRAINING.emptyScheduleName' | translate}}
                        </span>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'VSS.TRAINING.FORM.description' | translate}} EN</label>
                        <input type="text" class="form-control form-control-sm" id="name_en" name="name_en"
                            formControlName="name_en" placeholder="Example: " />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="form-row align-items-center">
                        <label class="col-sm-3 col-form-label">{{'VSS.TRAINING.FORM.startDate' |
                            translate}}</label>
                        <div class="col-auto">
                            <div class="input-group input-group-sm">
                                <input class="form-control" placeholder="yyyy-mm-dd" name="startDate" ngbDatepicker
                                    #startDatepicker="ngbDatepicker" formControlName="startDate" readonly>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" (click)="startDatepicker.toggle()"
                                        type="button">
                                        <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="small form-text text-danger text-center"
                        *ngIf="scheduleFormGroup.hasError('startDateRequired')">
                        {{'GENERAL.required' | translate}}
                    </span>
                </div>
                <div class="col-4">
                    <div class="form-row align-items-center">
                        <label class="col-sm-3 col-form-label">{{'VSS.TRAINING.FORM.endDate' |
                            translate}}</label>
                        <div class="col-auto">
                            <div class="input-group input-group-sm">
                                <input class="form-control" placeholder="yyyy-mm-dd" name="endDate" ngbDatepicker
                                    #endDatepicker="ngbDatepicker" formControlName="endDate" readonly
                                    [minDate]="scheduleFormGroup.get('startDate').value">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" (click)="endDatepicker.toggle()"
                                        type="button">
                                        <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="small form-text text-danger text-center" *ngIf="scheduleFormGroup.errors">
                        <ng-container *ngIf="scheduleFormGroup.hasError('endDateRequired')">
                            {{'GENERAL.required' | translate}}
                        </ng-container>
                        <ng-container *ngIf="scheduleFormGroup.hasError('endBeforeStart')">
                            End date can not be before start date
                        </ng-container>
                    </span>
                </div>
                <div class="col-auto">
                    <div class="form-check mt-2">
                        <input class="form-check-input" type="checkbox" id="fullYearCheck" name="fullYear"
                            formControlName="fullYear">
                        <label class="form-check-label" for="fullYearCheck">
                            {{'VSS.TRAINING.FORM.fullYear' | translate}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="row mt-1" formArrayName="scheduleTime">
                <div class="col">
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm m-0 border-0 p-1">
                            <thead>
                                <tr>
                                    <th scope="col">{{'VSS.TRAINING.FORM.openingHour' | translate}}</th>
                                    <th scope="col">{{'VSS.TRAINING.FORM.closingHour' | translate}}</th>
                                    <!-- <th scope="col">Lunch Time</th> -->
                                    <th scope="col" style="width: 7%;">{{'VSS.TRAINING.FORM.mon' | translate}}</th>
                                    <th scope="col" style="width: 7%;">{{'VSS.TRAINING.FORM.tue' | translate}}</th>
                                    <th scope="col" style="width: 7%;">{{'VSS.TRAINING.FORM.wed' | translate}}</th>
                                    <th scope="col" style="width: 7%;">{{'VSS.TRAINING.FORM.thu' | translate}}</th>
                                    <th scope="col" style="width: 7%;">{{'VSS.TRAINING.FORM.fri' | translate}}</th>
                                    <th scope="col" style="width: 7%;">{{'VSS.TRAINING.FORM.sat' | translate}}</th>
                                    <th scope="col" style="width: 7%;">{{'VSS.TRAINING.FORM.sun' | translate}}</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let scheduleTimeFormGroup of scheduleFormGroup.get('scheduleTime')['controls']; let i=index">
                                    <ng-container [formGroup]="scheduleTimeFormGroup">
                                        <td>
                                            <ngb-timepicker formControlName="openingHour" [spinners]="false"
                                                size="small">
                                            </ngb-timepicker>
                                            <span class="small form-text text-danger"
                                                *ngIf="getScheduleFormGruop(i).get('openingHour').hasError('zeroOpeningHourError')">
                                                {{getScheduleFormGruop(i).get('openingHour').errors | json}}
                                            </span>
                                        </td>
                                        <td>
                                            <ngb-timepicker formControlName="closingHour" [spinners]="false"
                                                size="small">
                                            </ngb-timepicker>
                                            <span class="small form-text text-danger"
                                                *ngIf="getScheduleFormGruop(i).hasError('closingHourError')">
                                            </span>
                                        </td>
                                        <ng-container formGroupName="openingDays">
                                            <td>
                                                <div>
                                                    <input type="checkbox" class="form-check-input form-control"
                                                        formControlName="1"
                                                        style="margin: 0 auto; width: 100%; height: 30px;" />
                                                </div>
                                            </td>
                                            <td>
                                                <input type="checkbox" class="form-check-input form-control"
                                                    formControlName="2"
                                                    style="margin: 0 auto; width: 100%; height: 30px;" />
                                            </td>
                                            <td>
                                                <input type="checkbox" class="form-check-input form-control"
                                                    formControlName="3"
                                                    style="margin: 0 auto; width: 100%; height: 30px;" />
                                            </td>
                                            <td>
                                                <input type="checkbox" class="form-check-input form-control"
                                                    formControlName="4"
                                                    style="margin: 0 auto; width: 100%; height: 30px;" />
                                            </td>
                                            <td>
                                                <input type="checkbox" class="form-check-input form-control"
                                                    formControlName="5"
                                                    style="margin: 0 auto; width: 100%; height: 30px;" />
                                            </td>
                                            <td>
                                                <input type="checkbox" class="form-check-input form-control"
                                                    formControlName="6"
                                                    style="margin: 0 auto; width: 100%; height: 30px;" />
                                            </td>
                                            <td>
                                                <input type="checkbox" class="form-check-input form-control"
                                                    formControlName="7"
                                                    style="margin: 0 auto; width: 100%; height: 30px;" />
                                            </td>
                                        </ng-container>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-sm btn-danger"
                                                (click)="deleteScheduleTimeControl(i)">
                                                <fa-icon [icon]="icons['faTimes']">
                                                </fa-icon>
                                            </button>
                                        </td>
                                    </ng-container>
                                </tr>
                                <tr>
                                    <td colspan="11" class="text-center">
                                        <button type="button" class="btn btn-sm btn-outline-primary"
                                            (click)="onAddTimeScheduleElement()">
                                            {{'VSS.TRAINING.FORM.addSchedules' | translate}}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <span class="small form-text text-danger" *ngIf="scheduleFormGroup.hasError('emptyScheduleTime')">
                Please add a Schedule time
            </span>
            <div class="row mt-3">
                <div class="col text-center">
                    <button type="button" class="btn btn-sm btn-outline-danger me-1"
                        (click)="cancelCurrentAction()">{{'GENERAL.cancel' | translate}}</button>
                    <button type="submit" class="btn btn-sm btn-outline-success"
                        *ngIf="scheduleForm.statusChanges">{{'GENERAL.save' | translate}}</button>
                </div>
            </div>
        </form>
    </section>
    <div class="row mt-3">
        <div class="col text-center">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="scheduleAction = 'create'"
                [hidden]="scheduleAction">{{'VSS.TRAINING.FORM.addSchedules' | translate}}</button>
        </div>
    </div>
    <h4 class="border-bottom pb-2 color-primary mb-3">{{'VSS.TRAINING.titleScheduleDescription' | translate}}
        <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
            {{'VSS.TRAINING.titleScheduleDescriptionDesc' | translate}}
        </small>
    </h4>
    <section>
        <form #priceDescriptionForm='ngForm' (ngSubmit)="onScheduleDescriptionSubmit()"
            [formGroup]="scheduleDescriptionFormGroup">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{'GENERAL.german' | translate}}</label>
                        <quill-editor id="scheduleDescription_de" name="scheduleDescription_de"
                            [styles]="{height: '150px'}" formControlName="scheduleDescription_de">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </div>

                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'GENERAL.italian' | translate}}</label>
                        <quill-editor id="scheduleDescription_it" name="scheduleDescription_it"
                            [styles]="{height: '150px'}" formControlName="scheduleDescription_it">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'GENERAL.ladin' | translate}}</label>
                        <quill-editor id="scheduleDescription_en" name="scheduleDescription_en"
                            [styles]="{height: '150px'}" formControlName="scheduleDescription_en">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </div>
                </div>
            </div>
            <div class="row mt-1">
                <div class="col text-end">
                    <button type="submit" class="btn btn-primary btn-sm">{{'GENERAL.save' | translate}}</button>
                </div>
            </div>
        </form>
    </section>
    <section class="mt-2 mb-2">
        <h4 class="border-bottom pb-2 color-primary">{{'VSS.TRAINING.filesTitle' | translate}}
            <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                {{'VSS.TRAINING.filesTitleHelpText' | translate}}
            </small>
        </h4>
        <div class="row">
            <app-vss-files-upload class="col" [type]="'trainingSession'" [organizationId]="currentOrganizationId">
            </app-vss-files-upload>
        </div>
    </section>
    <hr />
    <section *ngFor="let schedule of schedules; let i=index">
        <app-training-session-schedule-item [elementIndex]="i"></app-training-session-schedule-item>
    </section>
</div>
<app-toast></app-toast>
<app-confirm-modal #confirmModal></app-confirm-modal>
